import { render } from "./DataProtection.vue?vue&type=template&id=6669ab8a&scoped=true"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"

import "./DataProtection.vue?vue&type=style&index=0&id=6669ab8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6669ab8a"]])

export default __exports__